// extracted by mini-css-extract-plugin
export default {"Activation_title-text":"activation_Activation_title-text__46aUV"};